// Meta (Facebook) Pixel - client-side tracking.
//
// Inerte por padrão: se LECARTTE_META_PIXEL_ID estiver vazio, todas as
// funções viram no-op. Isso permite deixar o código mergeado em produção
// e "ligar" o pixel só setando a env var, sem novo deploy de código.

const PIXEL_ID = process.env.LECARTTE_META_PIXEL_ID || '';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

/**
 * Injeta o snippet oficial do Meta Pixel, inicializa com o PIXEL_ID e
 * dispara o PageView inicial. Seguro chamar uma única vez no boot do app.
 * No-op no servidor (SSR), quando o ID está vazio, ou se já foi carregado.
 */
export const initMetaPixel = (): void => {
  if (typeof window === 'undefined') return; // SSR guard
  if (!PIXEL_ID) return; // pixel desligado
  if (window.fbq) return; // idempotente

  /* eslint-disable */
  // Snippet base oficial do Meta (fbevents.js).
  (function (f: any, b: Document, e: string, v: string) {
    if (f.fbq) return;
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    const s = b.getElementsByTagName(e)[0];
    s.parentNode?.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  // Cast reseta o narrowing do guard `if (window.fbq) return` acima — a IIFE
  // definiu window.fbq, mas o control-flow do TS não rastreia essa mutação.
  const fbq = window.fbq as ((...args: unknown[]) => void) | undefined;
  fbq?.('init', PIXEL_ID);
  fbq?.('track', 'PageView');
};

/**
 * Dispara um evento padrão do Meta Pixel (ex: 'Lead', 'CompleteRegistration').
 * No-op se o pixel não estiver carregado.
 * @param event Nome do evento padrão do Meta
 * @param params Parâmetros opcionais do evento
 */
export const trackPixel = (event: string, params?: Record<string, unknown>): void => {
  if (typeof window === 'undefined') return;
  window.fbq?.('track', event, params);
};
